/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair2bpl/style.css';
import FormStructure from './thecateredaffair2bpl/form_structure';

export default FormStructure;